import React from 'react';
import Icon, { IconProps } from '../Icon';

const UserAddIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="auto"
        viewBox="0 0 45 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.6597 45.4079H8.84348C5.95234 45.4079 3.5714 43.0269 3.5714 40.1358V37.4147C3.5714 30.442 9.35368 24.6597 16.3264 24.6597H24.6597C29.4216 24.6597 33.6732 27.2107 35.8841 31.4624C36.3943 32.3127 37.4147 32.6528 38.265 32.1426C39.1154 31.6324 39.4555 30.612 38.9453 29.7617C36.7344 25.51 32.8229 22.6189 28.4012 21.5985C31.1222 19.3876 32.6528 15.9863 32.6528 12.2448C32.6528 5.44214 27.2107 0 20.408 0C13.6054 0 8.16321 5.44214 8.16321 12.2448C8.16321 15.9863 9.86388 19.3876 12.4149 21.5985C5.27207 23.2992 0 29.7617 0 37.2446V39.9657C0 44.7276 3.91154 48.6391 8.67341 48.6391H24.4896C25.51 48.6391 26.1903 47.9589 26.1903 46.9385C26.1903 45.9181 25.6801 45.4079 24.6597 45.4079ZM11.5645 12.4149C11.5645 7.48295 15.4761 3.57141 20.408 3.57141C25.34 3.57141 29.2515 7.48295 29.2515 12.4149C29.2515 17.3468 25.34 21.2584 20.408 21.2584C15.4761 21.2584 11.5645 17.3468 11.5645 12.4149Z"
          fill="currentColor"
        />
        <path
          d="M43.0269 40.9865H38.9453V36.9048C38.9453 35.8844 38.265 35.2042 37.2446 35.2042C36.2242 35.2042 35.5439 35.8844 35.5439 36.9048V40.9865H31.4623C30.4419 40.9865 29.7617 41.6667 29.7617 42.6871C29.7617 43.7075 30.4419 44.3878 31.4623 44.3878H35.5439V48.2993C35.5439 49.3197 36.2242 50 37.2446 50C38.265 50 38.9453 49.3197 38.9453 48.2993V44.2177H43.0269C44.0473 44.2177 44.7276 43.5375 44.7276 42.5171C44.7276 41.4967 44.0473 40.9865 43.0269 40.9865Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default UserAddIcon;
